<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.notification.notificationList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <!-- <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert> -->

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.notification.notificationList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="notifications.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.notification.name')}}</th>
                                    <th>{{$t('form.notification.programType')}}</th>
                                    <th>{{$t('form.notification.type')}}</th>
                                     <th>{{$t('form.notification.email')}}</th>
                                     <th>{{$t('form.notification.mobile')}}</th>
                                     <th>{{$t('form.notification.student_number')}}</th>
                                    <th>{{$t('form.notification.subject')}}</th>
                                    <th>{{$t('form.notification.message')}}</th>
                                     <th>{{$t('form.notification.status')}}</th>
                                      <th>{{$t('form.notification.status_message')}}</th>
                                    <th>{{$t('form.notification.created_at')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(notify, index) in notifications" v-bind:key="index">
                                    <td>{{notify.student}}</td>
                                    <td>{{notify.programType}}</td>
                                    <td>{{notify.type}}</td>
                                    <td>{{notify.email}}</td>
                                    <td>{{notify.mobile}}</td>
                                    <td>{{notify.alumni_number}}</td>
                                    <td>{{notify.subject}}</td>
                                    <td>{{notify.message | strip}}</td>
                                    <td>{{notify.sms_sent }} {{notify.sms_sent && notify.email_sent ? '&' : null}} {{notify.email_sent}}</td>
                                    <td>{{notify.sms_message}} {{notify.sms_message && notify.email_message ? '&' : null}} {{notify.email_message}}</td>
                                    <td>{{notify.created_at}}</td>

                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',
                
                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                notifications: []
            }
        },

        mounted() {

            if (!this.permissions.viewNotifications) {
                return this.$router.push('/');
            }
            this.isLoading = true;
            setTimeout(this.getNotifications(), 10000)
            
        },

        methods: {

            getNotifications() {
                axios
                    .get('/api/notifications?page=' + this.pagination.current_page)
                    .then(response => {
                        
                        this.notifications = response.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getNotifications();
            }
        }
    }

</script>
